import Button from '@components/interactive/Button';
import EmailInput from '@components/interactive/EmailInput';

export enum CtaTypes {
  link = 'LINK',
  button = 'BUTTON',
  email = 'EMAIL',
}

type Props = {
  ctaType: CtaTypes;
  buttonText: string;
  onSubmit?: any;
  href?: string;
  width?: any;
};

const CTA = ({ ctaType, buttonText, onSubmit = null, href = null, width = '450px' }: Props) => {
  const linkUrl = href ? new URL(href) : null;
  const isExternal = linkUrl && typeof window !== 'undefined' && linkUrl.origin !== window.location.origin;

  if (ctaType === CtaTypes.button) {
    return (
      <Button onSubmit={onSubmit} href={href} target={isExternal ? '_blank' : null} px={14}>
        {buttonText}
      </Button>
    );
  }
  return <EmailInput buttonText={buttonText} onSubmit={onSubmit} width={width} />;
};

export default CTA;
